import { render, staticRenderFns } from "./RestaurantCreateOrEdit.vue?vue&type=template&id=bb20946e&"
import script from "./RestaurantCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./RestaurantCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports